import { useMemo } from "react";
import { localizedNumber } from "../../../utils/help/localization/localization";
import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { resolveOfferSum } from "../../../utils/loyalty/offerCopy";
import { useFixedBundleSum } from "./useFixedBundleSum";

/**
 * Offer copy ready to render, with `{sum}` resolved.
 *
 * Only a bundle whose items are fixed carries the token, and only there is the
 * figure knowable up front. Where it is not, {@link resolveOfferSum} takes the
 * strikethrough away with it rather than leaving a guest a literal `{sum}`.
 */
export const useOfferDescriptionHtml = (
  offer: LoyaltyOffer | undefined,
  text: string | undefined
): string => {
  const sum = useFixedBundleSum(offer);

  return useMemo(
    () => (text ? resolveOfferSum(text, sum, localizedNumber) : ""),
    [text, sum]
  );
};
